/**
 * Product Roadmap page — route segment, CDN assets, section layout.
 * User-facing copy lives in `productRoadmapMessages.ts` (react-intl / Transifex).
 */
export const PRODUCT_ROADMAP_2026_SEGMENT = 'product-updates/roadmap-2026';

/**
 * Author details, used for the two spots that render the name directly (not via i18n).
 * The name itself is hardcoded into each translated string (see productRoadmapMessages.ts)
 * rather than interpolated as a placeholder, so translators can pick correct grammatical
 * gender/agreement for Andrea Parodi in each language.
 */
export const PRODUCT_ROADMAP_AUTHOR = {
  firstName: 'Andrea',
  lastName: 'Parodi',
} as const;

/** Contentful CDN assets for the Product Roadmap page. */
export const PRODUCT_ROADMAP_ASSETS = {
  heroImage:
    'https://images.ctfassets.net/cocwkk0wzcrd/6k0A20OEDrfKBhb4gfiCGN/010c483261ca96c823cba197c7192eed/hero-image.png',
  avatar:
    'https://images.ctfassets.net/cocwkk0wzcrd/zvV0WJySku623XIHQFkNZ/5f3481488d5cc3f2cae9ad76dcd21a3a/ap-avatar.png',
  topOrganizersVideo:
    'https://videos.ctfassets.net/cocwkk0wzcrd/5JnO464y3EhrDtcQSURpOn/1c01805f5fea374e9b5882d90a584d5c/top-organizers.mp4',
  eventFlyersVideo:
    'https://videos.ctfassets.net/cocwkk0wzcrd/5GaAnPCMkiCnU8hnY5A97o/c835d4b72a115319fec3e51ded11f2a8/event-flyers.mp4',
  newOrgProfilesVideo:
    'https://videos.ctfassets.net/cocwkk0wzcrd/2paOyaEeXUZP8GmUVmH1Rq/da452bd14e88a4af4872f604bc008d74/new-org-profiles.mp4',
  addToWalletVideo:
    'https://videos.ctfassets.net/cocwkk0wzcrd/77XtwyDaKsMrespkcrMbLd/54798861a77400c82a47d87b9db703c4/add-to-wallet.mp4',
} as const;

export type ProductRoadmapInlineVisual =
  | { kind: 'video'; src: string }
  | { kind: 'image'; src: string };

/** Inline visuals between copy segments (`ProductRoadmapPage`), keyed by section. */
export const productRoadmapInlineVisualsBySection: Record<
  string,
  readonly ProductRoadmapInlineVisual[]
> = {
  eventReach: [
    { kind: 'video', src: PRODUCT_ROADMAP_ASSETS.newOrgProfilesVideo },
    { kind: 'video', src: PRODUCT_ROADMAP_ASSETS.topOrganizersVideo },
    { kind: 'video', src: PRODUCT_ROADMAP_ASSETS.eventFlyersVideo },
  ],
  ticketing: [{ kind: 'video', src: PRODUCT_ROADMAP_ASSETS.addToWalletVideo }],
};

/** HeadSEO flags and canonical URL (title/description come from `productRoadmapMessages`). */
export const productRoadmap2026SeoStatic = {
  shouldIndex: true,
  shouldFollow: true,
  canonicalUrl: `https://www.eventbrite.com/${PRODUCT_ROADMAP_2026_SEGMENT}/`,
} as const;
